(function () {
  'use strict';

  // Fix: pressing Enter in any text input whose owning form posts to
  // /cart/add was auto-submitting the form (browser default behavior for
  // Enter-in-form-input), causing an unwanted add-to-cart when shoppers
  // typed in the Gigit Q&A or other embedded inputs.
  //
  // This guard preventDefault()s Enter in text inputs that belong to a
  // /cart/add form. The ATC button click still works normally.

  function onKeydown(e) {
    if (e.key !== 'Enter') return;
    var el = e.target;
    if (!el) return;
    var tag = (el.tagName || '').toLowerCase();
    if (tag !== 'input' && tag !== 'textarea') return;
    if (tag === 'input') {
      var type = (el.type || 'text').toLowerCase();
      // Don't interfere with actual form buttons / choice inputs
      if (type === 'submit' || type === 'button' || type === 'reset'
          || type === 'checkbox' || type === 'radio' || type === 'file') return;
    }
    // Determine owning form (explicit form attribute or DOM ancestor)
    var form = el.form || (typeof el.closest === 'function' ? el.closest('form') : null);
    if (!form) return;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/cart/add') === -1) return;

    // Cancel the default (form submission) but allow other listeners to run.
    try { e.preventDefault(); } catch (_) {}
  }

  document.addEventListener('keydown', onKeydown, true);
})();
